export default __webpack_public_path__ + "static/media/argentino.8c78143f.png";